import React from 'react';

import FooterNav from './footer_nav';

import { datasetStore, videoStore, eventsStore, spacecraftStore, previewStore, poiStore, gmapStore, layersStore, nisarStore } from '../managers/globalState';
import globalRefs from '../managers/globalRefs';
import VITALS_DATA from '../data/vitals_data';
import { DEM_MODELS } from '../data/dem';
import { NISAR_ITEMS } from '../data/nisar';
import { getSandMovementItems, getMethaneProjectGmap, METHANE_GMAP_ID } from '../helpers/processProjects';
import ar from '../languages/ar';
import '../../www/assets/css/vital_signs.css';
import { SAND_EVENT_IDS } from '../config/constants';
import { getLimitedLatestEvents } from '../helpers/processEvents';
import { getLimitedPois } from '../helpers/processPoI';
import { getLimitedGmaps } from '../helpers/processGmap';

/**
 * TODO: This component can be simplified into a function and merged with footer nav.
 */
class VitalSigns extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedClass: 'selected'
        };

        // Binds
        this._renderItems = this._renderItems.bind(this);
        this._handlePoISelection = this._handlePoISelection.bind(this);
        this._handleGmapSelection = this._handleGmapSelection.bind(this);
        this.getRelatedDatasetsList = this.getRelatedDatasetsList.bind(this);
        // this.scrollToItem = this.scrollToItem.bind(this);
        this.language = ar;
    }

    componentDidMount() {
        this.gmapUnsubscribe = gmapStore.subscribeTo('currentGmap', () => this.forceUpdate());
        this.gmapsUnsubscribe = gmapStore.subscribeTo('gmaps', () => this.forceUpdate());
        this.nisarUnsubscribe = nisarStore.subscribeTo('currentNisar', () => this.forceUpdate());
        this.demUnsubscribe = layersStore.subscribeTo('dem', () => this.forceUpdate());
        this.demModelUnsubscribe = layersStore.subscribeTo('demModelId', () => this.forceUpdate());
        this.vsUnsubscribe = datasetStore.subscribeTo('currentVS', () => this.forceUpdate());
        this.currentEventUnsubscribe = eventsStore.subscribeTo('currentEvent', () => this.forceUpdate());
        this.currentSpacecraftUnsubscribe = spacecraftStore.subscribeTo('currentSpacecraft', () => this.forceUpdate());
        this.videosUnsubscribe = videoStore.subscribeTo('currentVideo', currentVideo => {
            this.setState({ selectedClass: currentVideo?.type === 'global' ? '' : 'selected' });
        });
        this.eventPreviewUnsubscribe = previewStore.subscribeTo('previewEventData', () => this.forceUpdate());
    }

    componentWillUnmount() {
        typeof this.gmapUnsubscribe === 'function' && this.gmapUnsubscribe();
        typeof this.gmapsUnsubscribe === 'function' && this.gmapsUnsubscribe();
        typeof this.nisarUnsubscribe === 'function' && this.nisarUnsubscribe();
        typeof this.demUnsubscribe === 'function' && this.demUnsubscribe();
        typeof this.demModelUnsubscribe === 'function' && this.demModelUnsubscribe();
        typeof this.vsUnsubscribe === 'function' && this.vsUnsubscribe();
        typeof this.currentEventUnsubscribe === 'function' && this.currentEventUnsubscribe();
        typeof this.currentSpacecraftUnsubscribe === 'function' && this.currentSpacecraftUnsubscribe();
        typeof this.videosUnsubscribe === 'function' && this.videosUnsubscribe();
        typeof this.eventPreviewUnsubscribe === 'function' && this.eventPreviewUnsubscribe();
    }

    _renderItems() {
        const { latestEvents, currentEvent, events } = eventsStore.stateSnapshot;
        const { spacecraftId } = spacecraftStore.stateSnapshot;
        const { previewEventData } = previewStore.stateSnapshot;
        const { currentPoi } = poiStore.stateSnapshot;
        const { currentGmap } = gmapStore.stateSnapshot;

        const { dem, demModelId } = layersStore.stateSnapshot;

        if (dem) {
            return DEM_MODELS.map(({ id, title }) => (
                <li
                    key={id}
                    className={demModelId === id ? 'selected' : ''}
                    onClick={() => globalRefs.getManager('scene').showDemModel(id)}
                >
                    <a className='list-value'>{title}</a>
                </li>
            ));
        }

        const { currentNisar } = nisarStore.stateSnapshot;
        const sandId = [currentGmap?.eventId, currentGmap?.id, currentGmap?.external_id,
            currentEvent?.id, currentEvent?.external_id].find(id => SAND_EVENT_IDS.includes(id));

        if (sandId) {
            return getSandMovementItems().map(({ id, eventId, title }) => (
                <li
                    key={id}
                    className={sandId === eventId ? 'selected' : ''}
                    onClick={() => globalRefs.getManager('route').navigateToSand(eventId)}
                >
                    <a className='list-value'>{title}</a>
                </li>
            ));
        }

        if (currentNisar) {
            return NISAR_ITEMS.map(({ external_id, title }) => (
                <li
                    key={external_id}
                    className={currentNisar.external_id === external_id ? 'selected' : ''}
                    onClick={() => globalRefs.getManager('route').navigateToNisar(external_id)}
                >
                    <a className='list-value'>{title}</a>
                </li>
            ));
        }

        if (currentGmap?.external_id === METHANE_GMAP_ID || currentGmap?.id === METHANE_GMAP_ID) {
            const methane = getMethaneProjectGmap(events);
            return (methane ? [methane] : []).map(({ external_id, title }) => (
                <li
                    key={external_id}
                    className='selected'
                    onClick={() => globalRefs.getManager('route').navigateToGmap(external_id)}
                >
                    <a className='list-value'>{title}</a>
                </li>
            ));
        }

        if (previewEventData) {
            return null;
        }

        if (spacecraftId) {
            // Todo: merge this.getRelatedDatasetsList with content manager's getRelatedDatasets - Task #3187.
            const relatedDatesets = this.getRelatedDatasetsList(spacecraftId);
            // Todo: No datasets currently available looks quite ugly. Perhaps displaying nothing would be better?
            // Is it really relevent to tell the user when there are not any related datasets?
            if (relatedDatesets.length === 0) {
                return ([
                    <li
                        key='none'
                        data-value='none'
                    >
                        {this.language.no_datasets}
                    </li>
                ]);
            }
            return relatedDatesets.map(dataset => {
                const { vitalSignParam, datasetParam, title } = dataset;
                return (
                    <li
                        key={`related-${datasetParam}`}
                        onClick={() => this._handleVitalClick(vitalSignParam, datasetParam)}
                    >
                        <a className='list-value'>
                            {title}
                        </a>
                    </li>
                );
            });
        } else if (currentGmap) {
            const limitedGmaps = getLimitedGmaps(undefined, currentGmap?.external_id || currentGmap?.id);

            if (!limitedGmaps?.length) {
                return ([
                    <li
                        key='none'
                        data-value='none'
                    />
                ]);
            }

            return limitedGmaps.map(({ external_id, title }) => (
                <li
                    key={external_id}
                    className={currentGmap?.external_id === external_id ? 'selected' : ''}
                    onClick={() => this._handleGmapSelection({ currentTarget: { dataset: { value: external_id } } })}
                >
                    <a
                        className='list-value'
                        onClick={event => {
                            event.preventDefault();
                            this._handleGmapSelection({ currentTarget: { dataset: { value: external_id } } });
                        }}
                    >
                        {title}
                    </a>
                </li>
            ));
        } else if (currentPoi) {
            const limitedPois = getLimitedPois(undefined, currentPoi?.external_id || currentPoi?.id);

            if (!limitedPois?.length) {
                return ([
                    <li
                        key='none'
                        data-value='none'
                    />
                ]);
            }

            return limitedPois.map(({ external_id, title }) => (
                <li
                    key={external_id}
                    className={currentPoi?.external_id === external_id ? 'selected' : ''}
                    onClick={() => this._handlePoISelection({ currentTarget: { dataset: { value: external_id } } })}
                >
                    <a
                        className='list-value'
                        onClick={event => {
                            event.preventDefault();
                            this._handlePoISelection({ currentTarget: { dataset: { value: external_id } } });
                        }}
                    >
                        {title}
                    </a>
                </li>
            ));
        } else if (currentEvent && latestEvents) {
            const limitedLatestEvents = getLimitedLatestEvents();

            // If there are no latest events, return a single empty list item.
            if (!limitedLatestEvents?.length) {
                return ([
                    <li
                        key='none'
                        data-value='none'
                    />
                ]);
            }

            // If there are latest events, return a list of the latest events.
            return limitedLatestEvents.map(({ urlParam, title, id }) => (
                <li
                    key={id}
                    className={currentEvent.urlParam === urlParam ? 'selected' : ''}
                    onClick={() => this._handleEventClick(urlParam)}
                >
                    <a className='list-value'>{title}</a>
                </li>
            ));
        } else {
            const { getManager } = globalRefs;
            const { vitalSignId } = getManager('content');
            const { isSatellitesNow } = spacecraftStore.stateSnapshot;
            const vitalValue = isSatellitesNow ? 'satellites' : vitalSignId;

            // filter out the vital signs that should go into the footer
            const filteredList = [...VITALS_DATA.filter(value => !value.hideFromFooter) || []];
            const { selectedClass } = this.state;

            return filteredList.map(({ id, value, title }) => (
                <li
                    key={id}
                    onClick={() => this._handleVitalClick(value)}
                    className={vitalValue === value ? selectedClass : ''}
                >
                    <a className='list-value'>
                        {title}
                    </a>
                </li>
            ));
        }
    }

    _handleVitalClick(vitalSignParam, datasetParam) {
        if (!vitalSignParam) {
            return;
        }
        const { getManager } = globalRefs;
        getManager('route').navigateToDataset({ vitalSignParam, datasetParam });
    }

    _handleEventClick(eventParam) {
        if (!eventParam) {
            return;
        }
        const { getManager } = globalRefs;
        getManager('route').navigateToEvent(eventParam);
    }

    _handlePoISelection(poi) {
        const { getManager } = globalRefs;
        const poiId = poi?.currentTarget?.dataset?.value;
        if (poiId) {
            getManager('route').navigateToPoi(poiId);
        }
    }

    _handleGmapSelection(gmap) {
        const { getManager } = globalRefs;
        const gmapId = gmap?.currentTarget?.dataset?.value;
        if (gmapId) {
            getManager('route').navigateToGmap(gmapId);
        }
    }

    getRelatedVSList(missionName) {
        const { vitalSignsListRef } = this.props;
        const relatedDatasets = [];
        vitalSignsListRef.map(element => {
            for (let i = 0; i < element.dataset_groupings.length; i++) {
                for (let j = 0; j < element.dataset_groupings[i].datasets_sorted[0].missions.length; j++) {
                    if (element.dataset_groupings[i].datasets_sorted[0].missions[j].external_id === missionName) {
                        const dsGrouping = element.dataset_groupings[i];
                        dsGrouping.vitalSign = element.value;
                        dsGrouping.altid = i;
                        dsGrouping.titleIndex = j;
                        relatedDatasets.push(dsGrouping);
                        break;
                    }
                }
            }
        });
        return relatedDatasets;
    }

    getRelatedDatasetsList(missionId) {
        const relatedDatasets = [];

        VITALS_DATA.forEach(vitalData => {
            vitalData.datasetGroups.forEach(group => {
                const { missionIds, urlParam } = group.datasets[0];

                if (missionIds.includes(missionId)) {
                    // { id, vitalSignId, altid, title }
                    relatedDatasets.push({
                        vitalSignParam: vitalData.value,
                        datasetParam: urlParam,
                        title: group.title
                    });
                }
            });
        });

        return relatedDatasets;
    }

    getFooterTitle() {
        // const { currentEvent } = eventsStore.stateSnapshot;
        const { currentEvent: rawCurrentEvent } = eventsStore.stateSnapshot;
        // console.log("rawCurrentEvent: ", rawCurrentEvent)
        const currentEvent = SAND_EVENT_IDS.includes(rawCurrentEvent?.id) ? null : rawCurrentEvent;
        const { currentSpacecraft } = spacecraftStore.stateSnapshot;
        const { previewEventData } = previewStore.stateSnapshot;
        const { currentPoi } = poiStore.stateSnapshot;
        const { currentGmap } = gmapStore.stateSnapshot;

        if (layersStore.stateSnapshot.dem) {
            return ar.latest_dem_models;
        }

        const sandId = [currentGmap?.eventId, currentGmap?.id, currentGmap?.external_id,
            rawCurrentEvent?.id, rawCurrentEvent?.external_id].find(id => SAND_EVENT_IDS.includes(id));
        if (sandId) {
            return ar.latest_sand_models;
        }
        if (nisarStore.stateSnapshot.currentNisar) {
            return ar.latest_nisar_images;
        }
        if (currentGmap?.external_id === METHANE_GMAP_ID || currentGmap?.id === METHANE_GMAP_ID) {
            return ar.latest_methane_analysis;
        }
        if (currentGmap) {
            return ar.latest_gmaps;
        }

        if (currentSpacecraft) {
            return ar.dataset;
        }

        if (currentEvent) {
            return ar.latest_events;
        }

        if (currentPoi) {
            return ar.latest_pois;
        }

        if (currentGmap) {
            return ar.latest_gmaps;
        }

        if (previewEventData) {
            return ar.event_preview;
        }

        return '';
    }

    render() {
        const footerTitle = this.getFooterTitle();

        return (
            <div id='vital-signs'>
                {footerTitle && (
                    <div className='title'>
                        <div>
                            {' '}
                            {footerTitle}
                            {' '}
                        </div>
                    </div>
                )}
                <FooterNav content={this._renderItems()} />
            </div>
        );
    }
}

export default VitalSigns;

